var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollctivHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.0881 2.27779C23.8772 -0.432431 19.1019 0.0550598 16.1547 3.06706L15.0004 4.24516L13.8462 3.06706C10.9048 0.0550598 6.12365 -0.432431 2.91277 2.27779C-0.766844 5.38844 -0.9602 10.9714 2.33271 14.3432L13.6704 25.9385C14.4028 26.6872 15.5922 26.6872 16.3246 25.9385L27.6623 14.3432C30.9611 10.9714 30.7677 5.38844 27.0881 2.27779Z",
    fill: "#CF1124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollctivHeart);
export default __webpack_public_path__ + "static/media/collctivHeart.e3e6db4bea83b0b87f40799c115310b9.svg";
export { ForwardRef as ReactComponent };